<template>
  <div id="page-product-details">
    <section-ancestors-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Edit Ancestor"
    />
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'facilities.sections.ancestors.list' })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from '@/components/mixins/NotificationMixin';
import SectionAncestorsForm from './SectionAncestorsForm';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "SectionEdit",
  components: {
    SectionAncestorsForm,
  },
  mixins: [NotificationMixin, ViewModelMixin, SaveModelMixin],
  data() {
    return {
      loading: false,
      references: ['Facility_FK', 'SectionParent_FK'],
      model: {},
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    },
  },
  methods: {
    async fetch(sectionId) {
      try {
        this.loading = true;

        const {data} = await this.$api.facilities.sections.getAncestor(
            sectionId,
            this.$route.params.ancestorId
        );

        this.model = data.data;
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        if (!this.model.id) {
          this.not_found = true
        }
      }
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      delete params.id;

      try {
        const {data} = await this.$api.facilities.sections.updateAncestor(
            params,
            this.$route.params.sectionId,
            this.$route.params.ancestorId
        );

        this.notifySuccess('Section Ancestor updated');
        await this.$router.push({ name: 'facilities.sections.ancestors.list' })
      } catch (e) {
        this.notifyError('Section Ancestor failed to be update');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
